export function formatDurationFromSeconds(seconds: number | null): string {
  if (seconds === null) {
    return '–'
  }

  const safeSeconds = Math.max(0, Math.round(seconds))
  const minutes = Math.floor(safeSeconds / 60)
  const rest = safeSeconds % 60

  if (minutes === 0) {
    return `${rest} s`
  }

  return rest === 0 ? `${minutes} min` : `${minutes} min ${rest} s`
}

/** Formats seconds as a clock, e.g. 200 -> "3:20". */
export function formatClock(seconds: number): string {
  const safeSeconds = Math.max(0, Math.floor(seconds))
  const minutes = Math.floor(safeSeconds / 60)
  const rest = safeSeconds % 60

  return `${minutes}:${rest < 10 ? '0' + rest : rest}`
}
